import {
  CompanyFeeGroup,
  CompanyType,
  CountryCode,
  ModulesEnableOptions,
} from '@aslanpay/portal-common-lib';

export interface CompanyFormProps {
  id: string;
  onStepAction: () => void;
  previousStep: () => void;
  canPrevStep: boolean;
}
export interface CompanyDetailsFormFields {
  name: string;
  displayName: string;
  countryCode: CountryCode;
  companyNumber: string;
  feeGroup?: CompanyFeeGroup;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  postcode: string;
  type: CompanyType;
  partnerId?: string;
}

export interface CompanyModulesFormFields {
  modules?: string[];
  moduleStatuses?: Record<string, ModulesEnableOptions>;
}

export interface ModuleInfo {
  title: string;
  description: string;
  provisionBeforeEnable?: boolean;
}

export const MODULE_DISPLAY_INFO: Record<string, ModuleInfo> = {
  ON_DEMAND_PAY: {
    title: 'On Demand Pay',
    description: 'Everyday on demand / flex pay.',
  },
  GIFTING: {
    title: 'Gifting',
    description: 'Awarding points to employees.',
  },
  RESERVE: {
    title: 'Set & Spend',
    description: 'Request an available balance for payday.',
  },
  DIGITAL_VOUCHERS: {
    title: 'Digital Vouchers',
    description: 'Digital vouchers for employees to use.',
  },
  SAVINGS: {
    title: 'Savings',
    description: 'Flexible Saver and Challenge Saver products for employees.',
  },
  REWARD_AND_RECOGNITION: {
    title: 'Reward & Recognition',
    description: 'Reward and recognise employees for their contributions.',
    provisionBeforeEnable: true,
  },
  BENEFITS_HOSTING: {
    title: 'Benefits Hosting',
    description: 'Host and manage employee benefits.',
    provisionBeforeEnable: true,
  },
};

export function formatModuleName(key: string): string {
  return key
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export type CompanyFormFields = CompanyDetailsFormFields | CompanyModulesFormFields;
